import React from "react"
import { graphql } from "gatsby"
import Link from "./link"
import CallToAction from "./call-to-action"

export const query = graphql`
  fragment TripleBenefitsFields on DatoCmsTripleBenefitsComponent {
    componentId: key
    id
    model {
      apiKey
    }
    titleComponent
    title
    preambleNode {
      childMarkdownRemark {
        html
      }
    }
    ctaLink
    ctaLabel
    ctaType
    hideFirst
    firstRow
    secondRow
    benefits {
      id
      image {
        url
      }
      heading
      blurbNode {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`

export interface TripleBenefitsProps
  extends Queries.TripleBenefitsFieldsFragment {
  variant?: (
    | "hidefirst"
    | "smallerpadding"
    | "o-wrapper-desktop"
    | "no-bottom-margin-mobile"
    | "first-row"
    | "second-row"
  )[]
}

const TripleBenefits = (props: TripleBenefitsProps) => {
  const preamble = props.preambleNode
    ? props.preambleNode.childMarkdownRemark.html
    : ""
  const ctatype = props.ctaType || "text"

  const classNames = ["c-triple-benefits o-wrapper o-row"]

  if (props.hideFirst) {
    classNames.push("-hidefirst")
  }

  if (props.firstRow) {
    classNames.push("-first-row")
  }

  if (props.secondRow) {
    classNames.push("-second-row")
  }

  if (props.variant) {
    props.variant.forEach(variant => {
      classNames.push(`-${variant}`)
    })
  }

  return (
    <section id={props.componentId} className={classNames.join(" ")}>
      {props.titleComponent && (
        <h2 className="c-content-header">{props.titleComponent}</h2>
      )}
      <div className="c-triple-benefits__content u-flex u-space-between u-flex-wrap u-flex-column">
        <div className="c-triple-benefits__item u-flex u-flex-column">
          <h2 className="c-heading--b">{props.title}</h2>
          <div
            dangerouslySetInnerHTML={{
              __html: preamble,
            }}
          />
          {props.ctaLink && ctatype === "button" && (
            <CallToAction url={props.ctaLink} color={"green"}>
              {props.ctaLabel}
            </CallToAction>
          )}

          {props.ctaLink && ctatype === "text" && (
            <Link url={props.ctaLink}>{props.ctaLabel}</Link>
          )}
        </div>

        {props.benefits &&
          props.benefits.map(item => (
            <div
              className="c-triple-benefits__item -icon u-flex u-flex-column u-vertical-center"
              key={item.id}
            >
              <div
                className="c-triple-benefits__item-img"
                style={{
                  backgroundImage: `url(${item.image && item.image.url})`,
                }}
              ></div>
              <div className="c-triple-benefits__item-content">
                <h3 className="c-label"> {item.heading}</h3>
                {item.blurbNode && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.blurbNode.childMarkdownRemark.html,
                    }}
                  />
                )}
              </div>
            </div>
          ))}
      </div>
    </section>
  )
}

export default TripleBenefits
